module.exports = __webpack_public_path__ + "5f1dc5c132f91d3d9b39a127f66b3447.png";